export default{name:"checkbtn",props:["isVisible","isChecked"],methods:{emitClick:function emitClick(){this.$emit("click")}},computed:{compIsVisible:function compIsVisible(){return this.isVisible},compIsChecked:function compIsChecked(){return this.isChecked}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/CheckBtn.vue
// module id = 242
// module chunks = 0